export default __webpack_public_path__ + "static/media/forest&fog.cc12a9de.jpg";